module.exports = "pegasus_template/assets/theme2/medium/3.jpg";